import { QUERYSTATUS_TASK, QUERYSTATUS_TASK_SUCCESSFUL, QUERYSTATUS_TASK_FAILED } from './actionTypes';

export const queryTaskStatusStart = (token) => {
    return {
        type: QUERYSTATUS_TASK,
        payload: { token }
    }
}

export const queryTaskStatusStartSuccessful = (msg) => {
    return {
        type: QUERYSTATUS_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const queryTaskStatusStartFailed = (msg) => {
    return {
        type: QUERYSTATUS_TASK_FAILED,
        payload: msg
    }
}
